var Memoizer = /** @class */ (function () {
    function Memoizer(selectors, reduce) {
        this.selectors = selectors;
        this.reduce = reduce;
    }
    Memoizer.prototype.hasChanged = function (newValues) {
        var _this = this;
        if (!this.values) {
            return true;
        }
        var index = newValues.findIndex(function (val, index) {
            var previousVal = _this.values[index];
            if (previousVal === val) {
                return false;
            }
            if (Array.isArray(val) && Array.isArray(previousVal) && val.length === 0 && previousVal.length === 0) {
                return false;
            }
            return true;
        });
        if (index > -1) {
            // console.warn(`Memoizer recalculated at ${index}`, this.values, newValues)
        }
        return index > -1;
    };
    Memoizer.prototype.getValue = function () {
        var newValues = this.selectors.map(function (selector) { return selector(); });
        if (!this.hasChanged(newValues)) {
            return this.cachedValue;
        }
        this.values = newValues;
        this.cachedValue = this.reduce.apply(this, this.values.concat([this.cachedValue]));
        return this.cachedValue;
    };
    return Memoizer;
}());
export default Memoizer;
var SameArray = /** @class */ (function () {
    function SameArray() {
        var _this = this;
        this.arr = [];
        this.setValue = function (newValues) {
            if (_this.previousInput === newValues) {
                return;
            }
            _this.arr.splice(0, _this.arr.length);
            _this.arr.push.apply(_this.arr, newValues);
            _this.previousInput = newValues;
        };
        this.getValue = function () { return _this.arr; };
    }
    return SameArray;
}());
export { SameArray };



//////////////////
// WEBPACK FOOTER
// ./js/asset/memoizer.ts
// module id = alF7
// module chunks = 1